import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import UploadSKRepository from '../Repositories/UploadSKRepository'


class UploadSKBloc {

    detailChannel = new Subject();
    uploadSkChannel = new Subject();
    repository = new UploadSKRepository()

    constructor() {
        this.detailChannel.next({status: apiResponse.INITIAL})
        this.uploadSkChannel.next({status: apiResponse.INITIAL})
    }

    fetchDetail = async (query) => {
        try {
            this.detailChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log("rxjs", "Channel unsubscribed")}
    }

    fetchUploadSk = async (query) => {
        try {
            this.uploadSkChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchUploadSk(query).then((result) => {
                this.uploadSkChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.uploadSkChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log("rxjs", "Channel unsubscribed")}
    }
}

export default UploadSKBloc